/* eslint-disable dot-notation */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Badge,
  Box,
  Skeleton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr
} from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import { FiEdit } from 'react-icons/fi'

import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { Link } from 'react-router-dom'
import { NotFound } from '../../../components/molecules/NotFound'
import { Pagination } from '../../../components/PaginationNew'
import { PermissionComponent } from '../../../components/Permissions'
import { useAuth } from '../../../hooks/auth'
import { getEquipments } from '../../../hooks/equipments/useEquipments'
import { LayoutList } from '../../../layouts/List'

// debounce
let timer: any = null

export function Equipments() {
  const { clinicId } = useAuth()
  const [t] = useTranslation('pageEquipments')
  const skeletonRepeat = [1, 2, 3, 4, 5, 6, 7]
  const [searchState, setSearchState] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [isActive, setIsActive] = useState(true)

  const {
    data: getEquipmentsData,
    refetch,
    isFetching,
    isLoading
  } = useQuery(['equipments', currentPage, searchState, isActive], () =>
    getEquipments(currentPage, searchState, isActive)
  )

  useEffect(() => {
    refetch()
  }, [])

  const SearchInputCallbackValue = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget

    clearTimeout(timer)

    timer = setTimeout(() => {
      setCurrentPage(1)
      setSearchState(value)
    }, 500)
  }, [])

  const ActiveCheckboxCallbackValue = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setIsActive(event.target.checked)
  }, [])

  return (
    <LayoutList
      title={t('title')}
      urlNew="/settings/equipments/create"
      refetch={refetch}
      isFetching={isFetching}
      capturaChange={(event: any) => SearchInputCallbackValue(event)}
      captureActiveChange={(event: any) => ActiveCheckboxCallbackValue(event)}
      spiCode="CUSTOMER_TAGS"
      isSearched={false}
    >
      <Box>
        <Table variant="striped" colorScheme="blue" size="sm">
          <Thead>
            <Tr>
              <Th>{t('tConvenio')}</Th>
              <Th>{t('tGrupo')}</Th>
              <Th>{t('tUso')}</Th>
              <Th>{t('tAtivo')}</Th>
              <Th>{t('tAcoes')}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {isLoading ? (
              <>
                {skeletonRepeat.map((skeleton) => (
                  <Tr>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                  </Tr>
                ))}
              </>
            ) : (
              <>
                {getEquipmentsData?.equipments.map((equipment, index: number) => (
                  <Tr key={equipment.id} maxHeight="40px">
                    <Td>
                      <Text fontSize="sm">{equipment.name}</Text>
                    </Td>
                    <Td>{equipment.group_name || '-'}</Td>
                    <Td>
                      {equipment.usage_status && (
                        <Badge
                          colorScheme={equipment.usage_status === 'available' ? 'green' : 'orange'}
                        >
                          {equipment.usage_status === 'available' ? 'Disponível' : 'Ocupado'}
                        </Badge>
                      )}
                    </Td>
                    <Td>
                      <Badge colorScheme={equipment.is_active ? 'green' : 'gray'}>
                        {equipment.is_active ? 'Ativo' : 'Inativo'}
                      </Badge>
                    </Td>

                    <Td>
                      <PermissionComponent spiCode="INSURANCES" ipCode="EDIT">
                        <Link
                          to={{
                            pathname: `/settings/equipments/update/${equipment.id}`,
                            state: equipment
                          }}
                        >
                          <Tooltip
                            label="Editar"
                            aria-label="editar"
                            hasArrow
                            placement="top-start"
                          >
                            <Box ml="1rem" w="24px">
                              <FiEdit color="#9699B0" size={16} style={{ cursor: 'pointer' }} />
                            </Box>
                          </Tooltip>
                        </Link>
                      </PermissionComponent>
                    </Td>
                  </Tr>
                ))}
              </>
            )}
          </Tbody>
        </Table>
        {getEquipmentsData?.totalCountOfPage === 0 && !isLoading && <NotFound />}
      </Box>
      {!(getEquipmentsData?.totalCountOfPage === 0 && !isLoading) && (
        <Pagination
          totalCountOfRegisters={getEquipmentsData?.totalCountOfPage || 0}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      )}
    </LayoutList>
  )
}
